import Container from '@mui/material/Container';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import {Typography }from '@mui/material';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutWrapper = styled(Container)`
    display: flex;
    align-items: center;
    background-color:#000;
    padding: 20px 24px;
    @media (min-width: 749px){
            height:100vh;
        }
    @media (max-width: 600px){
        padding-top: 50px;
        padding-bottom: 50px;
    }
`
const AboutHeading = styled(Typography)`
    font-size:60px;
    text-align:center;
    font-family:poppins;
    font-weight:900;
    color:#F3D332;
    @media(min-width: 1800px){
            font-size:170px;
        }
    @media (max-width: 1900px) and (min-width: 1300px){
            font-size:90px;
        }
`
const AboutImg = styled.img`
    width:80%;
    max-width:80%;
    height:auto;
    @media (max-width: 1300px) and (min-width: 750px){
            width:300px;
            max-width:300px;
            height:auto;
        }
    @media (max-width: 749px){
        width:200px;
        max-width:200px;
        height:auto;
    }
    @media (max-width: 1900px) and (min-width: 1300px){
        width:350px;
        max-width:350px;
        height:auto;
    }
    @media(min-width: 1901px){
        width:100%;
        max-width:100%;
        height:auto;
    }
`
const AboutImgWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
`
const AboutDescription = styled.p`
    color:#fff;
    font-size:12px;
    font-weight:400;
    @media (max-width: 1299px) and (min-width: 900px){
            font-size:14px;
        }
    @media (min-width: 1300px){
            font-size:16px;
        }
    @media(min-width: 2000px){
            font-size:30px;
        }
`
const AboutDescWrapper = styled(Grid)`
    display:flex;
    flex-direction: column;
    justify-content:center;

`
const ImgWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`
const BuyBtn = styled.a`
    color:#000;
    background:#F3D332;
    font-size:18px;
    font-weight:400;
    border-radius:10px;
    text-align:center;
    padding: 10px 20px;
    margin-right:10px;
    @media (max-width: 749px){
            font-size:16px;
        }
    @media (max-width: 1400px) and (min-width: 1024px){
            font-size:14px;
            width: 140px;
            padding: 10px 20px;
            border-radius:10px;
        }
    @media (min-width: 2000px){
            font-size:30px;
            padding: 20px 30px;
            margin-top:20px;
            border-radius:20px;
        }
`
const CommunityBtn = styled.div`
    margin-top:20px;
    @media (min-width: 768px){
        margin-top:30px;
    }
`

export default function About() {
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])

    return (
          <>
          <AboutWrapper maxWidth="xxl" id="about">
            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                    <AboutHeading variant='h1'>
                        About
                    </AboutHeading>
                </Grid>
                <AboutImgWrapper item xs={12} sm={5} md={5} lg={5} xl={5} >
                    <ImgWrapper>
                        <AboutImg data-aos="fade-right" src="./assets/About Boby.png" alt=""/>
                    </ImgWrapper>
                </AboutImgWrapper>
                <AboutDescWrapper data-aos="fade-left" item xs={12} sm={7} md={7} lg={7} xl={7} >
                    <AboutDescription variant='p'>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor 
                    invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
                     et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                     Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed 
                     diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. 
                     At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata 
                     sanctus est Lorem ipsum dolor sit amet.
                    </AboutDescription>
                    <AboutDescription>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
                    dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet 
                    clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur 
                    sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. 
                    At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
                    </AboutDescription>
                    <CommunityBtn>
                        <BuyBtn>Join Telegram Community</BuyBtn>
                    </CommunityBtn>
                </AboutDescWrapper>
            </Grid>
          </AboutWrapper>
          </>
    );
  }